<template>
    <modal @close="$emit('close')" :minWidthPx="'750'">
        <div class="text-main-text text-left font-normal pb-10 px-10">
            <h3 class="text-2xl mb-8">{{team.team.name}}</h3>
            <div class="info-item">
                <p class="info-item-header">Контактное лицо</p>
                <div class="flex justify-between items-center"><p class="info-item-data">{{contactPerson.name}}</p>
                <div v-if="false">
                <Networks :networkRaw="contactPerson.social_networks" />
                </div>
                </div>
            </div>
            <div class="flex justify-between items-center">
                <div class="info-item">
                    <p class="info-item-header">Телефон для связи</p>
                    <p class="info-item-data">{{contactPerson.phone}}</p>
                </div>
                <div class="info-item">
                    <p class="info-item-header">E-mail</p>
                    <p class="info-item-data">{{contactPerson.email}}</p>
                </div>
                <div class="info-item">
                    <p class="info-item-header">Кол-во игроков</p>
                    <p class="info-item-data">{{team.player_count}}</p>
                </div>
                <div class="info-item">
                    <p class="info-item-header">К оплате</p>
                    <p class="info-item-data">{{team.total_cost}} {{currencySign}}</p>
                </div>
            </div>

            <div v-if="this.team.team.company && isCorpLeague">
              <div class="info-item">
                <p class="info-item-header">Название компании</p>
                <p class="info-item-data">{{this.team.team.company.name}}</p>
              </div>
              <div class="info-item">
                <p class="info-item-header">Краткая информация</p>
                <p class="info-item-data">{{this.team.team.company.description}}</p>
              </div>
            </div>

            <div class="info-item">
                <p class="info-item-header">Комментарий</p>
                <p class="info-item-data">{{team.comment||'-'}}</p>
            </div>
            <div v-if="this.team.team.company && isCorpLeague" class="info-item">
                <p class="info-item-header">Логотип</p>
                <div class="w-full flex items-center">
                    <div v-for="(image, property) in images" :key="property" class="image-cont w-24 h-24 mr-4 border" @click="downloadLogo(property)">
                        <img :src="getExistingLogoPrev(image)" class="image" >
                        <div class="image-shadow"><img class="w-6 h-6" src="@/assets/SVG/download-data-white.svg" alt /></div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals.js';
import Modal from '@/views/modals/base-modal-white';
import FileDownload from 'js-file-download';
import { mapState } from 'vuex';
import psd from '@/assets/SVG/psd.svg';
import ai from '@/assets/SVG/ai.svg';
import Networks from './registration-layout/network-templates';

export default {
  name: 'TeamDescriptionModal',
  components: {
    Networks, Modal,
  },
  mixins: [ModalMixin],
  props: ['team', 'downloadImages', 'isCorpLeague'],

  data() {
    return {
      contactPerson: {},
    };
  },
  created() {
    this.team.creator.id ? this.contactPerson = this.team.creator : this.contactPerson = this.team.team.captain;
  },
  methods: {
    downloadLogo(property) {
      this.downloadImages([property]);
    },
    getExistingLogoPrev(urlImage) {
      if (/\.(psd)$/i.test(urlImage)) {
        return psd;
      }
      if (/\.(ai)$/i.test(urlImage)) {
        return ai;
      }
      return urlImage;
    },
  },

  computed: {
    ...mapState({
      currency: state => state.auth.user.currency,
    }),
    currencySign() {
      return this.currency === 'RUB' ? '₽' : '';
    },
    images() { // array of logos
      return this.team.team.company.media;
    },

  },


};

</script>

<style scoped>

.info-item {
    @apply flex flex-col justify-start mb-6;
}

.info-item-header {
    @apply text-additional-text text-10px mb-1 font-semibold;

}

.info-item-data {
    @apply text-main-text text-sm font-semibold;
}

.image-cont {
  @apply flex justify-center items-center relative;
  border-radius: 0.25rem;
}

.image {
    border-radius: 0.25rem;
    z-index: 0;
  }

  .image-shadow {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.726);
    border-radius: 0.25rem;
    color: white;
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    align-items: center;
    opacity: 0;
  }

  .image-shadow:hover {
      opacity: 1;
      color: transparent;
      cursor: pointer;
    }

</style>
